/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  ADD_GROUP: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.add.group',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'ADD_GROUP' },
      },
    },
    ADD_GROUP: {
      invoke: {
        id: 'addGroup',
        src: 'addGroup',
        onDone: {
          target: 'ADD_GROUP_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'ADD_GROUP_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    ADD_GROUP_SUCCESS: {
      type: 'final',
    },
    ADD_GROUP_FAILED: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
